module.exports = __webpack_public_path__ + "static/media/Note-Click-Enter-Textures-Click_in_00020.79d3921c.png";